// extracted by mini-css-extract-plugin
module.exports = {"paper":"papper_paper__z1ctC"};